import { DataBean } from "../DataBean";

export class WorkActivity extends DataBean {

  public async getWorkActivity(idworkactivity: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_getWorkActivity_Number",
      [idworkactivity]
    );
  }

  public async assingSprintToWorkActivity(IDWorkActivity: number, IDSprint: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_assingSprintToWorkActivity_Number_Number",
      [IDWorkActivity, IDSprint]
    );
  }

  public async removeSprintToWorkActivity(IDWorkActivity: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_removeSprintToWorkActivity_Number",
      [IDWorkActivity]
    );
  }


  public async getWorkActivityCatalogPorPropiedades(properties: any, maxRows?: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "java.util.List_getWorkActivityCatalogPorPropiedades_java.util.Map_Number",
      [properties, maxRows]
    );
  }

  public async getWorkActivityRender(page: number, rows: number, props: any, isBackLog?: boolean): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.shared.Report_getWorkActivityRender_Number_Number_java.util.Map_Boolean",
      [page, rows, props, isBackLog ?? null]
    );
  }

  public async assingIDEmployeeToWorkActivity(IDWorkActivity: number, IDEmployee: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_assingIDEmployeeToWorkActivity_Number_Number",
      [IDWorkActivity, IDEmployee]
    );
  }

  public async changeStateWorkActivityStatuses(IDWorkActivity: number, IDWorkActivityStatuses: number, IDEmployeeSolver: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_changeStateWorkActivityStatuses_Number_Number_Number",
      [IDWorkActivity, IDWorkActivityStatuses,  IDEmployeeSolver]
    );
  }



  public async deleteWorkActivity(idworkactivity: number): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "boolean_deleteWorkActivity_Number",
      [idworkactivity]
    );
  }

  public async updateWorkActivity(bean: any): Promise<any> {
    return this.getCustomService(
      "ProcessFlow",
      "com.advantage.processflow.bean.WorkActivity_updateWorkActivity_com.advantage.processflow.bean.WorkActivity",
      [
        {
          DataBeanProperties: bean,
          DataBeanName: "com.advantage.processflow.bean.WorkActivity",
        },
      ]
    );
  }
}
